export const NewCommentAttachActionTypes = {
    TOGGLE_COMMENT_ATTACH_PAGE_HIDDEN: 'TOGGLE_COMMENT_ATTACH_PAGE_HIDDEN',
    TOGGLE_COMMENT_ANONYMOUS: 'TOGGLE_COMMENT_ANONYMOUS',
    COMMENT_MESSAGE: 'COMMENT_MESSAGE',
    COMMENT_ATTACH: 'COMMENT_ATTACH',
};
